import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { ITimeEntryCategory } from '../models/time-entry-category';
import { TimeEntryCategoryService } from '../services/time-entry-category.service';

@Injectable({
  providedIn: 'root'
})
export class TimeEntryCategoriesResolver  {
  constructor(
    private timeEntryCategoryService : TimeEntryCategoryService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
    ): Observable<ITimeEntryCategory[]> {
    return this.timeEntryCategoryService.searchTimeEntryCategories({pageNumber: 0, pageSize: 999999})
    .pipe(
      map(response => response.data)
    )
  }
}
